export default {
    current_choice: 'Jelenlegi választás',
    book_now: 'Foglaljon most',
    minimum_age: 'Csak {age} éven felülieknek',
    excess_liability: 'Önrész',
    security_deposit: 'Kaució',
    fuel_policy: 'Üzemanyag-politika',
    like_for_like: 'Ugyanolyanra ugyanolyan',
    full_to_full: 'Tele tankkal átvétel, tele tankkal leadás',
    miles_per_rental: '{mileage} mérföld ingyenes bérlésenként',
    km_per_rental: '{mileage} km ingyenes bérlésenként',
    unlimited_mileage: 'Korlátlan mérföld',
    unlimited_mileage_km: 'Korlátlan km',
    non_amendable: 'Nem módosítható',
    non_refundable: 'Nem visszatéríthető',
    free_cancellation_until: 'Ingyenes lemondás eddig:',
    basic_free_cancellation: 'Ingyenes lemondás legfeljebb 48 órával a kezdési időpont előtt',
    cancellation_in_line_with: 'Lemondás a következők szerint:',
    tcs: 'ÁSZF',
    free_extras_on_collection: 'Két ingyenes extra átvételkor',
    glass_and_tyres_covered: 'Üveg és gumik fedezve',
    number_of_passengers: 'Utasok száma',
    number_of_bags: 'Csomagok száma',
    fuel_type: 'Üzemanyag típusa',
    co2: 'CO2',
    aircon: 'Légkondicionáló',
    transmission: 'Váltó',
    book_type: '{type} foglalása',
    debit_card_deposit: 'Betéti kártya elfogadott kaucióhoz',
    fast_track_included: 'Gyorsított ügyintézés benne van',
    view_all: 'Összes megtekintése',
};
